import React from 'react';
import PropTypes from 'prop-types';

import mixin from 'react-mixin';
import ActionButton from '../action/action_button.jsx';
import { FormAPI, FlashMessageAPI } from 'lecom-api';

const RealizeFlash = window.Flash;

@mixin.decorate(window.CssClassMixin)
export default class FormActionsGroup extends React.Component {
	static propTypes = {
		inputs: PropTypes.array,
		submitButton: PropTypes.object,
		actions: PropTypes.array,
		isLoading: PropTypes.bool,
		isMobile: PropTypes.bool,
	};

	static defaultProps = {
		themeClassKey: 'form.buttonGroup',
		inputs: [],
		submitButton: {
			name: 'button.send',
			icon: 'send'
		},
		actions: [],
		isLoading: false,
		isMobile: false,
		allInputsHidden: false,
	};

	componentDidMount() {
		this.tabOrder()
	}

	tabOrder(){
		let actions = this.props.actions;

		if(actions.length > 0){
			let actionsName = actions.map(n => n.name);

			for(var x=0; x < actionsName.length; x++){
				let name = actionsName[x];

				if($(`.${name}`).is(':visible') === true){
					$(`.${name}`)[0].setAttribute('tabindex', '0');
				}
			}
		}
	}

	areAllInputsHidden() {
		const inputs = this.props.inputs;
		let allHidden = true;

		for(let field in inputs) {
			const input = inputs[field];

			if (input.type === "GRID") {
				let formApi = FormAPI.form(input.formId);
				let field = formApi ? formApi.fields(input.id) : null;

				if (field && field.visible()) {
					allHidden = false;
					break;
				}
			}
			else {
				if (input.visible) {
					allHidden = false;
					break;
				}
			}
		}

		return allHidden;
	}

	renderActions() {
		if (!this.props.actions.length) {
			return '';
		}

		return this.props.actions
			.filter((actionProps) => {
				if (this.props.isMobile) {
					return actionProps.type !== 'link' && !actionProps.hidden;
				}

				return !actionProps.hidden;
			})
			.map((actionProps, index) => {
				return (
					<ActionButton
						disabled={this.props.isLoading}
						{...actionProps}
						element="a"
						key={"form_action__" + index}
						className={actionProps.name}
					/>
				);
			});
	}

	render() {
		let messageContent = Realize.i18n.t('form.errors.are_all_inputs_hidden');
		if (this.areAllInputsHidden()) {
			FlashMessageAPI.flash().addMessageIfNotExists({ message: messageContent, type: 'warning', canDismiss: false });
		} else {
			FlashMessageAPI.flash().removeMessageByContent(messageContent);
		}
		return (
			<div className={!this.props.isMobile ? this.className() : `${this.className()} mobile`}>
				{this.renderActions()}
			</div>
		);
	}
}
